
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { PlanReportAdd, WeekPlanList } from '@/types/operationMonthReport.d'

@Component
export default class extends Vue {
  private formData: PlanReportAdd = {
    planType: '',
    projectId: '',
    planStart: '',
    planEnd: '',
    status: '',
    yhWeekPlanList: [],
    yhMonthPlanList: []
  }

  private rangeDate: Array<string> = []
  private submitShow = false
  private loading = false
  private isEdit: number | null = null
  private oldData = ''
  private rules = {
    projectId: [
      { required: true, message: '请选择所属项目', trigger: 'change' }
    ],
    planStart: [
      { required: true, message: '请选择计划周期', trigger: 'change' }
    ],
    yhWeekPlanList: [
      { required: true, message: '请添加周工作明细', trigger: 'change' }
    ]
  }

  private tableRules = {
    content: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    standard: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    allDate: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    support: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    complete: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    labors: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ]
  }

  get normalProjectList () {
    return this.$store.state.normalProjectList
  }

  get reportId () {
    return this.$route.params.reportId || ''
  }

  get type () {
    return this.$route.params.type || ''
  }

  created () {
    this.formData.planType = this.type
    this.reportId && this.getDetail()
  }

  getDetail () {
    this.loading = true
    this.$axios.get(this.$apis.operationmanage.selectYhPlanReportByReportId, { reportId: this.reportId }).then((res) => {
      this.formData = res
      this.rangeDate = [this.formData.planStart, this.formData.planEnd]
      this.formData.yhWeekPlanList.forEach((item) => {
        item.allDate = [item.planStart, item.planEnd]
        item.isInput = false
      })
      this.formData.yhWeekPlanList = JSON.parse(JSON.stringify(this.formData.yhWeekPlanList))
    }).finally(() => {
      this.loading = false
    })
  }

  // 计划周期
  changetimers (val: string[]) {
    if (val && val[0] && val[1]) {
      this.formData.planStart = val[0]
      this.formData.planEnd = val[1]
    } else {
      this.formData.planStart = ''
      this.formData.planEnd = ''
    }
  }

  // 列表添加
  onAdd () {
    if (this.isEdit !== null) {
      this.$message.warning('请先保存！')
    } else {
      this.formData.yhWeekPlanList.push({
        type: this.type,
        content: '',
        standard: '',
        planStart: '',
        planEnd: '',
        support: '',
        labors: '',
        remarks: '',
        complete: '',
        isInput: true,
        allDate: []
      })
      this.$nextTick(() => {
        // 滚动到表格最底部
        ;(this.$refs.editTable as any).bodyWrapper.scrollTop = (this.$refs.editTable as any).bodyWrapper.scrollHeight
      })
      this.isEdit = this.formData.yhWeekPlanList.length - 1
    }
  }

  // 保存当条
  onSave (row: WeekPlanList, index: number) {
    ;(this.$refs.addTable as ElForm).validate((valid) => {
      if (valid) {
        row.isInput = false
        row.planStart = row.allDate[0]
        row.planEnd = row.allDate[1]
        this.$set(this.formData.yhWeekPlanList, index, this.formData.yhWeekPlanList[index]) // 重新渲染表格数据
        this.isEdit = null
      }
    })
  }

  // 列表编辑当条
  onEdit (row: WeekPlanList, index: number) {
    if (this.isEdit !== null) {
      this.$message.warning('请先保存！')
    } else {
      this.oldData = JSON.stringify(row)
      row.isInput = true
      this.isEdit = index
      this.$set(this.formData.yhWeekPlanList, index, this.formData.yhWeekPlanList[index]) // 重新渲染表格数据
    }
  }

  // 当条取消编辑
  onCancel (row: WeekPlanList, index: number) {
    this.isEdit = null
    if (this.oldData[index]) {
      // 是否为编辑
      this.formData.yhWeekPlanList[index] = JSON.parse(this.oldData)
      this.formData.yhWeekPlanList[index].isInput = false // 取消值不变
      this.$set(this.formData.yhWeekPlanList, index, this.formData.yhWeekPlanList[index]) // 重新渲染表格数据
    } else {
      this.formData.yhWeekPlanList.splice(index, 1)
    }
  }

  // 删除当条
  onDelete (index: number) {
    if (this.isEdit !== null) {
      this.$message.warning('请先保存！')
    } else {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData.yhWeekPlanList.splice(index, 1)
        this.$message.success('删除成功')
      })
    }
  }

  onSubmit (num: string) {
    (this.$refs.formData as ElForm).validate(valid => {
      if (valid) {
        if (this.isEdit !== null) {
          this.$message.warning('请先保存！')
        } else {
          this.formData.yhWeekPlanList.forEach(item => {
            delete item.isInput
            delete item.allDate
          })
          this.formData.status = num
          this.submitShow = true
          const url = this.reportId
            ? this.$apis.operationmanage.updateYhPlanReport
            : this.$apis.operationmanage.insertYhPlanReport
          this.$axios.post(url, {
            ...this.formData
          }).then(() => {
            this.$message.success('添加成功')
            this.closeAdd()
          }).catch(() => {
            this.formData.yhWeekPlanList.forEach(item => {
              item.isInput = false
              item.allDate = []
            })
          }).finally(() => {
            this.submitShow = false
          })
        }
      }
    })
  }

  // 关闭
  closeAdd () {
    this.$router.back()
  }
}
